// import React, { useEffect, useMemo, useState } from "react";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import DataTable from "../../../components/DataTable/DataTable";
// import Modal from "../../../components/Modal/Modal";
// import Button from "../../../components/Form/Button";
// import Input from "../../../components/Form/Input";
// import Textarea from "../../../components/Form/Textarea";
// import Select from "../../../components/Form/Select";
// import { useToast } from "../../../context/ToastContext";
// import { apiService } from "../../../services/api";
// import "./AdminCMS.css";

// const AdminCMS = () => {
//   const { showToast } = useToast();

//   const [cmsList, setCmsList] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

//   const [selectedCms, setSelectedCms] = useState(null);
//   const [formData, setFormData] = useState({
//     title: "",
//     slug: "",
//     content: "",
//     status: "active", // active / inactive
//   });

//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 10,
//     total: 0,
//     totalPages: 1,
//   });

//   const [search, setSearch] = useState("");

//   // ========== FETCH CMS LIST ==========
//   const fetchCmsPages = async () => {
//     try {
//       setLoading(true);
//       const params = {
//         page: pagination.page,
//         limit: pagination.limit,
//         search: search || undefined,
//       };

//       const resp = await apiService.getCmsPages(params);

//       // support both array + paginated object
//       const list = Array.isArray(resp)
//         ? resp
//         : Array.isArray(resp.data)
//         ? resp.data
//         : [];

//       setCmsList(list);

//       setPagination((prev) => ({
//         ...prev,
//         total: resp.total ?? prev.total,
//         totalPages: resp.totalPages ?? prev.totalPages,
//       }));
//     } catch (err) {
//       console.error("Failed to fetch CMS pages:", err);
//       showToast("Failed to load CMS pages", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCmsPages();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pagination.page, pagination.limit]); // search handled manually via button or debounce

//   // ========== HANDLERS ==========

//   const openAddModal = () => {
//     setSelectedCms(null);
//     setFormData({
//       title: "",
//       slug: "",
//       content: "",
//       status: "active",
//     });
//     setIsModalOpen(true);
//   };

//   const openEditModal = (row) => {
//     setSelectedCms(row);
//     setFormData({
//       title: row.title || "",
//       slug: row.slug || "",
//       content: row.content || "",
//       status: row.status || "active",
//     });
//     setIsModalOpen(true);
//   };

//   const openDeleteModal = (row) => {
//     setSelectedCms(row);
//     setIsDeleteModalOpen(true);
//   };

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//     setSelectedCms(null);
//   };

//   const handleDeleteClose = () => {
//     setIsDeleteModalOpen(false);
//     setSelectedCms(null);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const payload = {
//       title: formData.title,
//       slug: formData.slug,
//       content: formData.content,
//       status: formData.status,
//     };

//     try {
//       if (selectedCms) {
//         // edit
//         await apiService.updateCmsPage(selectedCms._id || selectedCms.id, payload);
//         showToast("CMS page updated successfully", "success");
//       } else {
//         // add
//         await apiService.createCmsPage(payload);
//         showToast("CMS page created successfully", "success");
//       }

//       handleModalClose();
//       fetchCmsPages();
//     } catch (err) {
//       console.error("Failed to save CMS page:", err);
//       showToast("Failed to save CMS page", "error");
//     }
//   };

//   const handleConfirmDelete = async () => {
//     if (!selectedCms) return;

//     try {
//       await apiService.deleteCmsPage(selectedCms._id || selectedCms.id);
//       showToast("CMS page deleted successfully", "success");
//       handleDeleteClose();
//       fetchCmsPages();
//     } catch (err) {
//       console.error("Failed to delete CMS page:", err);
//       showToast("Failed to delete CMS page", "error");
//     }
//   };

//   const handleSearch = () => {
//     setPagination((prev) => ({ ...prev, page: 1 }));
//     fetchCmsPages();
//   };

//   const columns = useMemo(
//     () => [
//       {
//         key: "title",
//         label: "Title",
//       },
//       {
//         key: "slug",
//         label: "Slug",
//       },
//       {
//         key: "status",
//         label: "Status",
//         render: (value) => (
//           <span
//             style={{
//               padding: "2px 8px",
//               borderRadius: 12,
//               fontSize: 12,
//               backgroundColor: value === "active" ? "#e6ffed" : "#ffecec",
//               color: value === "active" ? "#137333" : "#b00020",
//             }}
//           >
//             {value === "active" ? "Active" : "Inactive"}
//           </span>
//         ),
//       },
//       {
//         key: "updatedAt",
//         label: "Last Updated",
//         render: (value) =>
//           value ? new Date(value).toLocaleString("en-IN") : "—",
//       },
//       {
//         key: "actions",
//         label: "Actions",
//         sortable: false,
//         render: (value, row) => (
//           <div className="table-actions">
//             <Button
//               size="small"
//               variant="outline"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 openEditModal(row);
//               }}
//             >
//               Edit
//             </Button>
//             <Button
//               size="small"
//               variant="outline"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 openDeleteModal(row);
//               }}
//             >
//               Delete
//             </Button>
//           </div>
//         ),
//       },
//     ],
//     []
//   );

//   return (
//     <div className="admin-cms">
//       <PageHeader
//         title="CMS"
//         subtitle="Manage static pages and content"
//         actions={
//           <Button variant="primary" onClick={openAddModal}>
//             + Add CMS Page
//           </Button>
//         }
//       />

//       {/* Search bar */}
//       <div className="cms-filters">
//         <Input
//           placeholder="Search by title or slug..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//         <Button variant="outline" onClick={handleSearch}>
//           Search
//         </Button>
//       </div>

//       {/* Listing */}
//       <DataTable
//         columns={columns}
//         data={cmsList}
//         loading={loading}
//         searchable={false}
//         pagination={pagination}
//         onPageChange={(page) =>
//           setPagination((prev) => ({ ...prev, page }))
//         }
//         onLimitChange={(limit) =>
//           setPagination((prev) => ({ ...prev, limit, page: 1 }))
//         }
//         emptyMessage="No CMS pages found."
//       />

//       {/* Add/Edit Modal */}
//       <Modal
//         isOpen={isModalOpen}
//         onClose={handleModalClose}
//         title={selectedCms ? "Edit CMS Page" : "Add CMS Page"}
//         size="medium"
//       >
//         <form onSubmit={handleSubmit} className="cms-form">
//           <Input
//             label="Title *"
//             name="title"
//             value={formData.title}
//             onChange={handleChange}
//             required
//           />

//           <Input
//             label="Slug *"
//             name="slug"
//             value={formData.slug}
//             onChange={handleChange}
//             required
//             placeholder="e.g. about-us, privacy-policy"
//           />

//           <Textarea
//             label="Content *"
//             name="content"
//             value={formData.content}
//             onChange={handleChange}
//             rows={8}
//             required
//           />

//           <div className="form-group">
//             <label className="form-label">Status</label>
//             <Select
//               name="status"
//               value={formData.status}
//               onChange={handleChange}
//               options={[
//                 { value: "active", label: "Active" },
//                 { value: "inactive", label: "Inactive" },
//               ]}
//             />
//           </div>

//           <div className="modal-actions">
//             <Button variant="outline" type="button" onClick={handleModalClose}>
//               Cancel
//             </Button>
//             <Button variant="primary" type="submit">
//               {selectedCms ? "Update Page" : "Create Page"}
//             </Button>
//           </div>
//         </form>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal
//         isOpen={isDeleteModalOpen}
//         onClose={handleDeleteClose}
//         title="Delete CMS Page"
//         size="small"
//       >
//         <p>
//           Are you sure you want to delete{" "}
//           <strong>{selectedCms?.title || "this page"}</strong>? This action
//           cannot be undone.
//         </p>
//         <div className="modal-actions">
//           <Button variant="outline" onClick={handleDeleteClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleConfirmDelete}>
//             Yes, Delete
//           </Button>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default AdminCMS;




import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../../../components/PageHeader/PageHeader";
import DataTable from "../../../components/DataTable/DataTable";
import Modal from "../../../components/Modal/Modal";
import Button from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import Textarea from "../../../components/Form/Textarea";
import { useToast } from "../../../context/ToastContext";
import { apiService } from "../../../services/api";
import "./AdminCMS.css";

const AdminCMS = () => {
  const { showToast } = useToast();

  const [cmsList, setCmsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const [selectedCms, setSelectedCms] = useState(null);
  const [viewCms, setViewCms] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    content: "",
    image: "",
  });

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });

  const [search, setSearch] = useState("");

  // ========== FETCH CMS LIST ==========
  const fetchCmsPages = async () => {
    try {
      setLoading(true);

      const params = {
        search: search || undefined,
        page: pagination.page,
        limit: pagination.limit,
      };

      // expected backend endpoint: GET /admin/cms/listing?search=...
      // response shape (simplified in apiService): { error, status, data: [...], total, totalPages }
      const resp = await apiService.listCms(params);

      const list = Array.isArray(resp.data) ? resp.data : resp.data?.data ?? resp.data ?? [];

      setCmsList(list);

      setPagination((prev) => ({
        ...prev,
        total: resp.total ?? prev.total,
        totalPages: resp.totalPages ?? prev.totalPages,
      }));
    } catch (err) {
      console.error("Failed to fetch CMS pages:", err);
      showToast("Failed to load CMS pages", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCmsPages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, pagination.limit]); // search handled manually via Search button

  // ========== HANDLERS ==========

  const openAddModal = () => {
    setSelectedCms(null);
    setFormData({
      name: "",
      content: "",
      image: "",
    });
    setIsModalOpen(true);
  };

  const openEditModal = (row) => {
    setSelectedCms(row);
    setFormData({
      name: row.name || "",
      content: row.content || "",
      image: row.image || "",
    });
    setIsModalOpen(true);
  };

  const openDeleteModal = (row) => {
    setSelectedCms(row);
    setIsDeleteModalOpen(true);
  };

  const openViewModal = async (row) => {
    setIsViewModalOpen(true);
    setViewCms(null);
    setViewLoading(true);

    try {
      const id = row._id || row.id;
      const resp = await apiService.getCmsById(id);
      // backend: { error, status, message, data: { ...doc } }
      const cms = resp.data ?? resp;
      setViewCms(cms);
    } catch (err) {
      console.error("Failed to fetch CMS details:", err);
      showToast("Failed to load CMS details", "error");
      setViewCms(null);
    } finally {
      setViewLoading(false);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedCms(null);
  };

  const handleDeleteClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedCms(null);
  };

  const handleViewClose = () => {
    setIsViewModalOpen(false);
    setViewCms(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.name,
      content: formData.content,
      image: formData.image || "",
    };

    try {
      if (selectedCms) {
        // edit: PUT /admin/cms/edit/:id
        const id = selectedCms._id || selectedCms.id;
        await apiService.updateCms(id, payload);
        showToast("CMS page updated successfully", "success");
      } else {
        // create: POST /admin/cms/create
        await apiService.createCms(payload);
        showToast("CMS page created successfully", "success");
      }

      handleModalClose();
      fetchCmsPages();
    } catch (err) {
      console.error("Failed to save CMS page:", err);
      showToast("Failed to save CMS page", "error");
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedCms) return;

    try {
      // DELETE /admin/cms/delete/:id
      const id = selectedCms._id || selectedCms.id;
      await apiService.deleteCms(id);
      showToast("CMS page deleted successfully", "success");
      handleDeleteClose();
      fetchCmsPages();
    } catch (err) {
      console.error("Failed to delete CMS page:", err);
      showToast("Failed to delete CMS page", "error");
    }
  };

  const handleSearch = () => {
    setPagination((prev) => ({ ...prev, page: 1 }));
    fetchCmsPages();
  };

  // ========== TABLE COLUMNS ==========
  const columns = useMemo(
    () => [
      {
        key: "name",
        label: "Name",
      },
      {
        key: "slug",
        label: "Slug",
      },
      {
        key: "content",
        label: "Content",
        render: (value) => {
          if (!value) return "—";
          const text = String(value);
          return text.length > 80 ? `${text.slice(0, 80)}…` : text;
        },
      },
      {
        key: "updatedAt",
        label: "Last Updated",
        render: (value) =>
          value ? new Date(value).toLocaleString("en-IN") : "—",
      },
      {
        key: "actions",
        label: "Actions",
        sortable: false,
        render: (value, row) => (
          <div className="table-actions">
            <Button
              size="small"
              variant="outline"
              onClick={(e) => {
                e.stopPropagation();
                openViewModal(row);
              }}
            >
              View
            </Button>
            <Button
              size="small"
              variant="outline"
              onClick={(e) => {
                e.stopPropagation();
                openEditModal(row);
              }}
            >
              Edit
            </Button>
            <Button
              size="small"
              variant="outline"
              onClick={(e) => {
                e.stopPropagation();
                openDeleteModal(row);
              }}
            >
              Delete
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="admin-cms">
      <PageHeader
        title="CMS"
        subtitle="Manage static pages and content"
        actions={
          <Button variant="primary" onClick={openAddModal}>
            + Add CMS Page
          </Button>
        }
      />

      {/* Search bar */}
      <div className="cms-filters">
        <Input
          placeholder="Search by name, slug or content..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button variant="outline" onClick={handleSearch}
          style={{ padding: "9.5px 16px", fontSize: "14px", marginBottom: "20px" }}

        >
          Search
        </Button>
      </div>
      {/* Listing */}
      <DataTable
        columns={columns}
        data={cmsList}
        loading={loading}
        searchable={false}
        pagination={pagination}
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, page }))
        }
        onLimitChange={(limit) =>
          setPagination((prev) => ({ ...prev, limit, page: 1 }))
        }
        emptyMessage="No CMS pages found."
      />

      {/* Add/Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title={selectedCms ? "Edit CMS Page" : "Add CMS Page"}
        size="medium"
      >
        <form onSubmit={handleSubmit} className="cms-form">
          <Input
            label="Name *"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <Textarea
            label="Content *"
            name="content"
            value={formData.content}
            onChange={handleChange}
            rows={8}
            required
          />

          <Input
            label="Image URL"
            name="image"
            value={formData.image}
            onChange={handleChange}
            placeholder="Optional image URL"
          />

          <div className="modal-actions">
            <Button variant="outline" type="button" onClick={handleModalClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {selectedCms ? "Update Page" : "Create Page"}
            </Button>
          </div>
        </form>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={handleDeleteClose}
        title="Delete CMS Page"
        size="small"
      >
        <p>
          Are you sure you want to delete{" "}
          <strong>{selectedCms?.name || "this page"}</strong>? This action
          cannot be undone.
        </p>
        <div className="modal-actions">
          <Button variant="outline" onClick={handleDeleteClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            Yes, Delete
          </Button>
        </div>
      </Modal>

      {/* View Details Modal */}
      <Modal
        isOpen={isViewModalOpen}
        onClose={handleViewClose}
        title={viewCms?.name || "CMS Details"}
        size="medium"
      >
        {viewLoading ? (
          <p>Loading...</p>
        ) : !viewCms ? (
          <p>Unable to load CMS details.</p>
        ) : (
          <div className="cms-view-details">
            <p>
              <strong>Slug:</strong> {viewCms.slug || "—"}
            </p>
            {viewCms.image ? (
              <div style={{ margin: "10px 0" }}>
                <strong>Image:</strong>
                <div>
                  <img
                    src={viewCms.image}
                    alt={viewCms.name}
                    style={{ maxWidth: "100%", maxHeight: 200, marginTop: 8 }}
                  />
                </div>
              </div>
            ) : null}
            <div style={{ marginTop: 12 }}>
              <strong>Content:</strong>
              <div className="cms-view-content">
                <p style={{ whiteSpace: "pre-wrap", marginTop: 8 }}>
                  {viewCms.content}
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="modal-actions" style={{ marginTop: 16 }}>
          <Button variant="primary" onClick={handleViewClose}>
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default AdminCMS;
